<template><div><h1 id="auftragsposition" tabindex="-1"><a class="header-anchor" href="#auftragsposition"><span>Auftragsposition</span></a></h1>
<p>Auftragsposition — Eine Position in einem Auftrag</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In den Auftragspositionen sind der Umfang der Lieferung (Artikel), die Versandkosten und allfällige Spenden definiert.</p>
<p>Pfad: <code v-pre>Verkauf → Aufträge</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Pos.</dt>
<dd>Auftragspositionsnummer; wird vom System vergeben.</dd>
<dt>Artikel</dt>
<dd>Artikelnummer, aus <a class="link" href="ft.refdata.artikel.html" title="Artikel">Artikel</a>.<br>Beim Erfassen der Artikelnummer in der Auftragsposition prüft das Programm, ob der eingegebene Artikel im Lagersortiment vorhanden ist. Diese Kontrolle funktioniert auch, wenn unvollständige Artikelnummern eingegeben werden. Beispiel: Das System erkennt bei Eingabe eines Artikels K000.1 dass es:<div class="itemizedlist"><ul class="itemizedlist" style="list-style-type: disc; "><li class="listitem">diesen Artikel nicht gibt</li><li class="listitem">einen Artikel mit der Nummer K000.10 aber sehr wohl</li></ul></div>und ergänzt automatisch die Artikelnummer um diese eine Stelle.<br>Die verfügbaren Artikelmengen werden aufgrund des effektiv frei verfügbaren Bestandes angezeigt (lagerspezifisch). Wählt der Benutzer einen Artikel, der nicht im Lagersortiment ist, erhält er eine Warnmeldung &quot;Artikel nicht im Lagersortiment&quot;. Beim nächsten Fakturierungslauf werden solche Artikel abgesagt.</dd>
<dt>Medium</dt>
<dd>Das <a class="link" href="ft.refdata.tblmedium.html" title="Medium">Medium</a>, aus dem der Artikel bestellt wurde. Das Medium definiert, welche Response- Ereignisse für den Auftrag generiert werden.</dd>
<dt>Anzahl</dt>
<dd>Auftragsmenge</dd>
<dt>Artikelbezeichnung</dt>
<dd>Bezeichnung aus <a class="link" href="ft.refdata.artikel.html" title="Artikel">Artikel</a> (nur Anzeige).</dd>
<dt>Preis/Stk</dt>
<dd>Einzelpreis des Artikels aus <a class="link" href="ft.refdata.artikel.html" title="Artikel">Artikel</a>. Der Preis kann manuell, direkt in der Tabelle, angepasst werden.</dd>
<dt>- %</dt>
<dd>Rabatt in Prozent, der für die Auftragsposition gezogen wird, siehe im Detail <a class="link" href="Rabattstufen.html" title="9. Rabattstufen einrichten">Rabattstufen</a></dd>
<dt>Total</dt>
<dd>Gesamtpreis der Auftragsposition</dd>
<dt>Faktura</dt>
<dd>Fakturanummer (erst sichtbar, nachdem die Position geliefert oder abgesagt wurde).</dd>
<dt>Status</dt>
<dd>Auftragspositionsstatus:
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>vorreserviert</td>
<td>Artikel ist ist nicht an Lager. Bei Einlagerung wird er zu einem reservierten Artikel und kann geliefert werden.</td>
</tr>
<tr>
<td>reserviert</td>
<td>der Artikel ist verfügbar und für diesen Auftrag reserviert</td>
</tr>
<tr>
<td>vorreserviert VZ</td>
<td>Vorauszahlung, vorreserviert</td>
</tr>
<tr>
<td>reserviert VZ</td>
<td>Vorauszahlung, reserviert</td>
</tr>
<tr>
<td>intern geliefert</td>
<td>geliefert, fakturiert aus eigenem Lager</td>
</tr>
<tr>
<td>extern geliefert</td>
<td>geliefert, fakturiert aus externem Lager (Direktlieferant)</td>
</tr>
<tr>
<td>retourniert</td>
<td>Der Artikel ist vom Kunden retourniert worden</td>
</tr>
<tr>
<td>abgesagt</td>
<td>z.B. ausverkaufter Artikel, abgesagt durch Avisierungssystem oder wegen nicht bezahlter Vorauszahlung</td>
</tr>
</tbody>
</table>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="retouren-erfassen" tabindex="-1"><a class="header-anchor" href="#retouren-erfassen"><span>Retouren erfassen</span></a></h3>
<p>Erfassen einer Retoure zum Auftrag. Details sie <RouteLink to="/referenz/refs/ft.refproc.artretouren.html" title="Retouren erfassen">Retouren erfassen</RouteLink></p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.auftrag.html" title="Auftrag">Auftragskopf</RouteLink>, <RouteLink to="/manual/trade/auftragsverwaltung.html#Auftragsverwaltung" title="1. Auftragsverwaltung">Auftragsverwaltung</RouteLink>, <RouteLink to="/referenz/refs/ft.refproc.artretouren.html" title="Retouren erfassen">Retouren erfassen</RouteLink></p>
</div></template>


